module.exports = __webpack_public_path__ + "img/none.e290c34e.png";